import { Stack } from '@mui/material';
import PropTypes from 'prop-types';
import styles from './console.module.scss';

const ConsoleLayout = ({ children }) => {
  return (
    <Stack className={styles.root} sx={{ minHeight: '100%' }}>
      {children}
    </Stack>
  );
};

ConsoleLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export { Main } from './section/Main';
export { Section } from './section/Section';

export default ConsoleLayout;
